export default function About() {
  const principles = [
    {
      icon: "ri-focus-3-line",
      title: "画质优先",
      desc: "每一份图源都经过画质筛选与分级，从原图到精修，确保细节清晰、观感纯净。",
    },
    {
      icon: "ri-database-2-line",
      title: "分类清晰",
      desc: "按题材与画质档位精细归档，检索路径简洁，快速定位你想要的静态漫画内容。",
    },
    {
      icon: "ri-flashlight-line",
      title: "更新及时",
      desc: "新作上线与连载同步保持高效入库，第一时间呈现最新图源页面，不错过更新。",
    },
    {
      icon: "ri-heart-3-line",
      title: "尊重原作",
      desc: "以还原与收藏为初衷，保留作品原始神韵，让经典画面以最好的状态被看见。",
    },
  ];

  return (
    <section id="about" className="relative overflow-hidden bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-600">
              <i className="ri-information-line"></i>
              关于我们
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              以收藏之心，做清晰的漫画图源
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              静漫天堂是一个专注高清静态漫画图源的内容平台。我们相信，好的阅读体验从清晰开始——因此从入库、筛选到归档，每一环都以"画质"与"完整"为核心。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              我们收录经典长篇、热门新作与独立佳作，覆盖热血、古风、奇幻、都市、悬疑、治愈等多种题材，并按画质档位精细筛选，让漫画爱好者无论追更还是收藏，都能找到满意的清晰内容。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="flex gap-3 rounded-2xl border border-background-200/70 bg-background-50 p-4"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-lg text-background-50">
                    <i className={p.icon}></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-950">
                      {p.title}
                    </h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                      {p.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="overflow-hidden rounded-3xl border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20warm%20comic%20art%20of%20a%20cozy%20reading%20corner%20with%20stacked%20comic%20books%20and%20a%20warm%20lamp%20glow%2C%20crimson%20and%20amber%20palette%2C%20ink%20brush%20detail%2C%20artistic%20still%20life%2C%20soft%20lighting%2C%20no%20text&width=900&height=760&seq=jm-about&orientation=portrait"
                alt="静漫天堂漫画阅读收藏氛围插画"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 left-4 rounded-2xl bg-primary-500 px-5 py-4 text-background-50 shadow-[0_10px_30px_rgba(0,0,0,0.18)] md:-bottom-6 md:left-8">
              <div className="font-heading text-3xl text-accent-200">12,000+</div>
              <div className="mt-0.5 text-xs text-background-50/85">高清图源持续收录</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}